import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Button } from 'react-bootstrap'
import { PulseLoader } from 'react-spinners'

import {
  getAdverseEvent,
  setSelectedAdverseEventForPharmaVigilance,
  patchAdverseEvent,
  // updateAdverseEvent,
  getAdverseEventHistory,
  setAdverseEventHistory,
} from '../reducers/adverseEventsReducer'

import WithAuth from '../../../HOCs/WithAuth'
import LoadingScreen from '../../../components/LoadingScreen'
import ConfirmationPopover from '../../../components/ConfirmationPopover'
import AdverseEventTable from './AdverseEventTable'
// import AdverseEventRequiresRevisionsModal from './AdverseEventRequiresRevisionsModal'

class AdverseEventShowPage extends Component {

  // state = {
  //   showRequiresRevisionsModal: false,
  // }

  componentDidMount() {
    if (!this.props.selectedAdverseEvent) {
      this.props.getAdverseEvent(this.props.routerProps.match.params.id)
    }

    this.props.getAdverseEventHistory(this.props.routerProps.match.params.id, this.props.alert)
  }


  // componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.editingAdverseEvent && !this.props.editingAdverseEvent && this.state.showRequiresRevisionsModal) {
  //     this.toggleShowRequiresRevisionsModal()
  //   }
  // }


  componentWillUnmount() {
    this.props.setSelectedAdverseEventForPharmaVigilance(null)
    this.props.setAdverseEventHistory(null)
  }


  // toggleShowRequiresRevisionsModal = () => {
  //   this.setState({ 
  //     showRequiresRevisionsModal: !this.state.showRequiresRevisionsModal,
  //   })
  // }
  

  handleEditAdverseEvent = (data) => {
    if (this.props.editingAdverseEvent) {
      return
    }
    this.props.patchAdverseEvent(this.props.selectedAdverseEvent, data, this.props.alert)
  }

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })


  render() {
    const {
      fetchingAdverseEvents,
      selectedAdverseEvent,
      editingAdverseEvent,
      antibioticsUse,
      fetchingAdverseEventHistory,
      adverseEventHistory,
     } = this.props

    if (fetchingAdverseEvents || fetchingAdverseEventHistory) {
      return <LoadingScreen text="Loading" />
    } else if (!selectedAdverseEvent) {
      return <h2>Could not find Adverse Drug Effect</h2>
    } else {

      // const confirmationPopoverTitle = selectedAdverseEvent.addressed ? 'Mark ADR as active?' : 'Mark ADR as reconciled?'
      const confirmationPopoverTitle = 'Acknowledge receipt of report?'

      const confirmationPopoverText = selectedAdverseEvent.addressed ? 
        null 
        : 
        <p>
          {/* The ADR should only be marked as reconciled if contact has been made with the site and the data associated with the ADR has been confirmed. Once the ADR has been marked as reconciled, the data can no longer be modified. */}
          The ADR should only be acknowledged as received if contact has been made with the site and the data associated with the ADR has been confirmed.
        </p>

      return (
        <div className="ChartsContainer">
          {/* <AdverseEventRequiresRevisionsModal
            show={this.state.showRequiresRevisionsModal}
            handleCancel={this.toggleShowRequiresRevisionsModal}
            adverseEvent={selectedAdverseEvent}
            toggleRequiresRevisions={(requires_revisions) => this.handleEditAdverseEvent({ requires_revisions })}
            updateAdverseEvent={this.props.updateAdverseEvent}
            readOnly={selectedAdverseEvent.is_locked || selectedAdverseEvent.addressed}
          /> */}

          <AdverseEventTable
            {...selectedAdverseEvent}
            antibioticsUse={antibioticsUse}
            fetchingAdverseEventHistory={fetchingAdverseEventHistory}
            adverseEventHistory={adverseEventHistory}
            // toggleShowRequiresRevisionsModal={this.toggleShowRequiresRevisionsModal}
          />

          <div className="buttons-footer">
            <div className='buttons-row'>
              <div className='buttons-to-right'>
                {!selectedAdverseEvent.deleted && selectedAdverseEvent.is_locked !== true && selectedAdverseEvent.addressed !== true?
                  <Fragment>
                    <ConfirmationPopover
                      triggerButtonClass="adr-footer-button"
                      triggerVariant="success"
                      triggerText="Acknowledge Receipt of Report"
                      title={confirmationPopoverTitle}
                      placement="right"
                      popoverContent={confirmationPopoverText}
                      onConfirm={() => {
                        this.handleEditAdverseEvent({
                          addressed: !this.props.selectedAdverseEvent.addressed,
                          requires_revisions: false,
                        })
                      }}
                      confirmText={editingAdverseEvent ?
                        <PulseLoader
                          css={`display: block; margin: 0 auto;`}
                          color='white'
                        />
                        :
                        'Confirm'
                      }
                    />

                    {/* <Fragment>
                      {selectedAdverseEvent.addressed ?
                        null
                        :
                        <Button
                          variant='primary'
                          className='adr-footer-button'
                          disabled={editingAdverseEvent}
                          onClick={this.toggleShowRequiresRevisionsModal}
                        >
                          {selectedAdverseEvent.requires_revisions ?
                            'Validation Request'
                            :
                            'Request Validation'
                          }
                        </Button>
                      }
                    </Fragment> */}


                  </Fragment>
                  :
                  null
                }

                <Button 
                  className='adr-footer-button'
                  onClick={() => this.props.routerProps.history.push('/adverse-drug-reactions')}
                >
                  Back
              </Button>
              </div>
            </div>
          </div>
          <br/>
          <br/>
          <br/>
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    fetchingAdverseEvents: state.adverseEventsReducer.fetchingAdverseEvents,
    selectedAdverseEvent: state.adverseEventsReducer.selectedAdverseEvent,

    fetchingAdverseEventHistory: state.adverseEventsReducer.fetchingAdverseEventHistory,
    adverseEventHistory: state.adverseEventsReducer.adverseEventHistory,

    editingAdverseEvent: state.adverseEventsReducer.editingAdverseEvent,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAdverseEvent: (id, alert) => dispatch(getAdverseEvent(id, alert)),

    patchAdverseEvent: (adverseEvent, alert) => dispatch(patchAdverseEvent(adverseEvent, alert)),

    // updateAdverseEvent: (adverseEvent) => dispatch(updateAdverseEvent(adverseEvent)),

    setSelectedAdverseEventForPharmaVigilance: (adverseEvent) => {
      return dispatch(setSelectedAdverseEventForPharmaVigilance(adverseEvent))
    },

    getAdverseEventHistory: (adverseEvent, alert) => {
      return dispatch(getAdverseEventHistory(adverseEvent, alert))
    },

    setAdverseEventHistory: (adverseEventHistory) => {
      return dispatch(setAdverseEventHistory(adverseEventHistory))
    },
  }
}


export default WithAuth(connect(mapStateToProps, mapDispatchToProps)(AdverseEventShowPage))
